import { render, staticRenderFns } from "./FabricPermissionCreateEdit.vue?vue&type=template&id=3e2ff634&scoped=true&"
import script from "./FabricPermissionCreateEdit.vue?vue&type=script&lang=js&"
export * from "./FabricPermissionCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./FabricPermissionCreateEdit.vue?vue&type=style&index=0&id=3e2ff634&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2ff634",
  null
  
)

export default component.exports